import React from 'react';

import { CardMetricPropTypes } from './CardMetric.types';
import NextImage from '../NextImage';

const CardMetric: React.FC<CardMetricPropTypes> = ({
  id,
  className = '',
  title,
  productIcons,
  children,
}) => {
  return (
    <div
      id={id}
      className={`w-full max-w-[56.4rem] overflow-hidden rounded-[1.2rem] bg-background-secondary p-[2rem] shadow-prime ${className}`}
    >
      <header className='mb-[2rem] flex items-center'>
        <h3 className='mr-auto text-[2.2rem] font-semibold text-primary md:text-[3.6rem]'>{title}</h3>
        <div className='flex gap-[1rem]'>
          {productIcons?.map(({ alt, url }) => {
            return (
              <NextImage
                key={url}
                alt={alt}
                className='w-[2.2rem] md:w-[3.6rem]'
                width={36}
                src={url}
              />
            );
          })}
        </div>
      </header>

      {children}
    </div>
  );
};

export default CardMetric;
